// @ts-strict-ignore
import React from 'react'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { Box, Callout, DataListItem, RowsSkeletonLoader } from '@node-space/ui-components'
import { DateFormat } from 'constants/General'
import { MIN_PAGINATION_SIZE } from 'constants/queries'
import { ContactCase } from 'types/contacts'
import { useContactCaseSidePanelHelper } from '../hooks/useContactCaseSidePanelHelper'
import { ChannelPaymentSidePanelBody } from './ChannelPaymentSidePanelBody'
import { DepositSidePanelBody } from './DepositSidePanelBody'
import { PaymentInSidePanelBody } from './PaymentInSidePanelBody'

export type ContactCaseSidePanelBodyProps = {
  contactCase: ContactCase
}

export const ContactCaseSidePanelBody = ({ contactCase }: ContactCaseSidePanelBodyProps) => {
  const { t } = useTranslation()

  const paymentContextType = contactCase?.paymentContext?.type

  const {
    isLoading,
    isError,
    payment,
    channel,
    isChannelPayment,
    isPaymentIn,
    isDirectDeposit,
    isWithdrawal,
  } = useContactCaseSidePanelHelper({
    contactCase,
    paymentContextType,
  })

  return (
    <>
      {isError && !isLoading && (
        <Callout variant="error">{t('somethingWentWrongFetchTransaction')}</Callout>
      )}

      {isLoading && !isError && <RowsSkeletonLoader rows={MIN_PAGINATION_SIZE} />}

      {!isLoading && !isError && (
        <Box flexCol gapY={12}>
          <h4 className="text-h4 text-foreground-prominent">{t('transactionDetails')}</h4>
          {(isDirectDeposit || isWithdrawal) && <DepositSidePanelBody contactCase={contactCase} />}

          {isPaymentIn && <PaymentInSidePanelBody payment={payment} contactCase={contactCase} />}
          {isChannelPayment && (
            <ChannelPaymentSidePanelBody channel={channel} contactCase={contactCase} />
          )}

          <DataListItem
            id="date"
            testId="date"
            title={t('date')}
            body={dayjs(contactCase?.paymentCreated).format(DateFormat.D_MMM_YYYY_AT_HH_MM)}
          />
        </Box>
      )}
    </>
  )
}
